module.exports = {"230811008":"云环街道","230811009":"英俊街道","230811010":"红旗街道","230811011":"友谊街道","230811101":"大来镇","230811102":"敖其镇","230811103":"望江镇","230811104":"长发镇","230811105":"莲江口镇","230811106":"西格木镇","230811107":"沿江镇","230811108":"四丰镇","230811200":"长青乡","230811208":"平安乡","230811211":"群胜乡","230811480":"莲江口监狱","230811579":"郊区农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230811.json
// module id = 858
// module chunks = 0